export const REQUEST_ACCEPT_CALCULATION = 'REQUEST_ACCEPT_CALCULATION' as const;
export const REQUEST_ACCEPT_CALCULATION_SUCCESS =
  'REQUEST_ACCEPT_CALCULATION_SUCCESS' as const;
export const REQUEST_ACCEPT_CALCULATION_FAILED =
  'REQUEST_ACCEPT_CALCULATION_FAILED' as const;
